import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ModalHeader } from '../../component/ModalRef';
import { actionSearch } from '../../module/modal/PdfViewModule';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import { LinearProgress } from '@material-ui/core';

/* 모달을 닫기 위해서 modalRef를 반드시 전달받아야 함 */
const PdfViewModal = ({ fileUid, fileSize, modalRef }) => {
    const dispatch = useDispatch();
    const [fileUrl, setFileUrl] = useState(null);
    const [downloadSize, setDownloadSize] = useState(0);

    useEffect(() => {
        dispatch(
            actionSearch({
                params: { fileUid },
                callback: (fileUrl) => {
                    setFileUrl(fileUrl);
                },
                downloadProgress: (loaded) => {
                    setDownloadSize(loaded);
                },
            }),
        );
    }, []);

    const handleConfirm = () => {
        modalRef.current.close();
    };

    return (
        <>
            <ModalHeader title={'강의계획서'} modalRef={modalRef} />
            <div className='PdfViewModal '>
                <div className='modal-body '>
                    <div className='con-inner '>
                        {downloadSize < fileSize ? (
                            <LinearProgress variant='determinate' value={(downloadSize / fileSize) * 100} />
                        ) : (
                            <></>
                        )}
                        {fileUrl && (
                            <object
                                className='embed'
                                style={{ width: '100%', height: 600 }}
                                data={fileUrl}
                                type='application/pdf'
                            />
                        )}
                    </div>
                    <div className='modal-btn-wrap'>
                        <ConfirmButtonBox title='확인' onClick={() => handleConfirm()} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default PdfViewModal;
